import React from 'preact';

interface IProps {
    handleClose: any;
}

const TopTips = ({ handleClose }: IProps) => {
    return (
        <div className="modal fade show">
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Top Tips for writing a review</h5>
                        <button type="button" className="close" onClick={() => handleClose()}>
                            <span>&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <div className="mb-2">
                            <h6>Do's</h6>
                            <ul>
                                <li>Do make sure the review is current and relevant </li>
                                <li>Do write about your own first-hand personal experiences</li>
                                <li>Do provide useful and honest feedback</li>
                                <li>Do make sure your review is a minimum of 200 characters and a maximum of 1,000 characters</li>
                                <li>Do proofread your review to check your review makes sense</li>
                            </ul>
                        </div>
                        <div>
                            <h6>Don'ts</h6>
                            <ul>
                                <li>Don't do a review on behalf of someone else but if required, the caregiver can provide assistance</li>
                                <li>Don't copy another review </li>
                                <li>Don't use the names of any individual or identifying features </li>
                                <li>Don't include abusive remarks or allegations of negligence or criminal activity</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TopTips;
